// import AdminPanel from "./AdminPanel";
// import Navbar from "../../components/Navbar";
// import React, { useState } from "react";

// const AdminPage = ({
//   setCurrentNickname,
//   currentNickname,
//   handleLogout,
//   setFormType,
// }) => {
//   const [userId, setUserId] = useState("");

//   return (
//     <div >
//       <Navbar
//         setCurrentNickname={setCurrentNickname}
//         currentNickname={currentNickname}
//         setFormType={setFormType}
//         handleLogout={handleLogout}
//         showButtons={true}
//         PlutonicuserID={userId}
//       />
//       <div className="mt-20" > 
//         <AdminPanel />
//       </div>
//     </div>
//   );
// };

// export default AdminPage;


import TherapistAdminPanel from "./TherapistAdminPanel";
import Navbar from "../../components/Navbar";
import React from "react";

const TherapistAdminPage = () => {
  return (
    <div>
      <Navbar />
      <div className="min-h-screen flex items-center justify-center -mt-20">
        <TherapistAdminPanel />
      </div>
    </div>
  );
};

export default TherapistAdminPage;
